import React from 'react';
import { Clock, ExternalLink } from 'lucide-react';
import { useRecentFiles } from '../../hooks/useStorage';
import { FileText, Folder } from 'lucide-react';

export default function RecentDocuments() {
  const { files, loading } = useRecentFiles();

  if (loading) {
    return (
      <div className="space-y-2">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="h-10 bg-gray-100 rounded-lg animate-pulse" />
        ))}
      </div>
    );
  }

  if (!files.length) {
    return (
      <div className="flex flex-col items-center gap-2 py-8 text-gray-400">
        <Clock className="w-8 h-8" />
        <p className="text-sm">No recent documents</p>
      </div>
    );
  }

  return (
    <div className="space-y-1">
      {files.map((file) => (
        <div
          key={`${file.provider}-${file.id}`}
          className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-50 group"
        >
          {file.isFolder ? (
            <Folder className="w-4 h-4 text-amber-400 flex-shrink-0" />
          ) : (
            <FileText className="w-4 h-4 text-blue-400 flex-shrink-0" />
          )}
          <span className="flex-1 text-sm text-gray-700 truncate">{file.name}</span>
          <span className="text-xs text-gray-400 capitalize hidden sm:block">{file.provider}</span>
          {file.webUrl && (
            <a
              href={file.webUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-0 group-hover:opacity-100 transition-opacity text-gray-400 hover:text-indigo-600"
              title="Open"
            >
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
          )}
        </div>
      ))}
    </div>
  );
}
